/** Today in Europe/Berlin as YYYY-MM-DD (the restaurant's calendar day). */
export const todayInBerlin = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(
    new Date()
  );

/**
 * YYYY-MM-DD as DD.MM.YYYY. Kept here instead of utils/helper's
 * toEuropeanDate, which pulls Firebase and the calendar into the settings.
 */
export const europeanDate = (date: string) => date.split('-').reverse().join('.');

/** Translation key of the notification order. */
export const orderLabel = (usePriority: boolean) => (usePriority ? 'Priority first' : 'First come, first served');

/** A whole number within the API's bounds, or null while the text is empty or invalid. */
export const wholeNumber = (value: string, min: number, max: number) => {
  if (!/^\d+$/.test(value.trim())) return null;
  const number = Number(value);
  return number >= min && number <= max ? number : null;
};
